<div class="container" (window:resize)="onResize()">
    <mat-card *ngFor="let user of users" (mouseenter)="currentUser = user;">
        <mat-card-content>
            <div>
                <img [src]="user.image" alt="200x200" width="60px" height="60px">
            </div>
            <div class="badge-details">
                <div>
                    <span *ngIf="!hidePaText">Personal Assistant: </span><span class="mat-card-name">{{ user.paName }}</span>
                </div>
            </div>
            <div class="badge-price">
                <h3>£0.00</h3>
            </div>
           <div class="badge-btn">
                <button mat-raised-button (click)="editUser();">
                    <mat-icon>create</mat-icon><span *ngIf="!hideText"> Edit</span>
                </button>
           </div>
           <div class="badge-btn">
                <button mat-raised-button (click)="deleteUser();">
                    <mat-icon>delete</mat-icon><span *ngIf="!hideText"> Delete</span>
                </button>
           </div>
        </mat-card-content>
    </mat-card>
    <br>
    <div *ngIf="users.length !== 0" class="checkout-container">
        <div>
            <h3><b>Total Price: £{{ getBasketTotal() }}.00</b></h3>
        </div>
        <div>
            <button mat-raised-button (click)="checkout();">
                <mat-icon>shopping_cart</mat-icon><span> Checkout</span>
            </button>
        </div>
        <div>
            <button mat-raised-button (click)="redirectToHome();">
                <mat-icon>add</mat-icon><span> Add badge</span>
            </button>
        </div>
    </div>
    <div *ngIf="users.length === 0" class="no-badge-container">
        <div>
            <h2>No badges in basket.</h2>
        </div>
        <div>
            <button mat-raised-button (click)="redirectToHome();">
                <mat-icon>add</mat-icon><span> Add badge</span>
            </button>
        </div>
    </div>
</div>
